export const SCROLLSPY_LOCALE = {
    guide: 'Nav'
};
